module.exports = __webpack_public_path__ + "static/media/menuLunch.aeaf83fd.png";